/**
 * This file was auto-generated.
 * Do not make direct changes to the file.
 */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { z } from 'zod'

import * as CommonTypes from './common-types'

export const PaymentProvider = {
	AdyenTerminal: 'ADYEN_TERMINAL',
	AdyenEcom: 'ADYEN_ECOM',
	BlikkEcom: 'BLIKK_ECOM',
	BlikkPos: 'BLIKK_POS',
	Cash: 'CASH',
	CashAsync: 'CASH_ASYNC',
	VippsMobilepay: 'VIPPS_MOBILEPAY',
	NetsTerminal: 'NETS_TERMINAL',
	VerifoneCheckout: 'VERIFONE_CHECKOUT',
	VerifoneEcom: 'VERIFONE_ECOM',
	StraumurEcom: 'STRAUMUR_ECOM'
} as const
export type PaymentProviderType = (typeof PaymentProvider)[keyof typeof PaymentProvider]
export const StoreOrderStatus = {
	Draft: 'DRAFT',
	Completed: 'COMPLETED',
	Canceled: 'CANCELED'
} as const
export type StoreOrderStatusType = (typeof StoreOrderStatus)[keyof typeof StoreOrderStatus]
export type QuantityInfo = {
	quantity: number
} & (
	| {
			pricingMethod: 'PER_UNIT'
	  }
	| {
			pricingMethod: 'PRICE_EMBEDDED'
			price: CommonTypes.Amount
	  }
	| {
			pricingMethod: 'PER_WEIGHT' | 'WEIGHT_EMBEDDED'
			weight: number
	  }
)
export type StoreOrderItemFee = {
	uuid: string
	feeUuid: string
	name: string
	totals: CommonTypes.TaxAmount
	quantity: number
	unitPrice: CommonTypes.TaxAmount
}
export type StoreOrderItemDiscount = {
	uuid: string
	name: string
	totals: CommonTypes.TaxAmount
}
export type StoreOrderItem = {
	uuid: string
	productTitle: string
	variantTitle: string
	variantImageUrl?: string
	sku?: string
	variantUuid: string
	scannedBarcode?: string
	totals: CommonTypes.TaxAmount
	unitPrice?: CommonTypes.TaxAmount
	itemTotals: CommonTypes.TaxAmount
	feeTotals: CommonTypes.TaxAmount
	discountTotals: CommonTypes.TaxAmount
	quantityInfo: QuantityInfo
	itemFees: StoreOrderItemFee[]
	itemDiscounts: StoreOrderItemDiscount[]
}
export type StoreOrderItemGroup = {
	uuid: string
	items: StoreOrderItem[]
	priceInfo:
		| {
				shouldOverridePrice: true
				totals: CommonTypes.TaxAmount
				itemTotals: CommonTypes.TaxAmount
				discountTotals: CommonTypes.TaxAmount
				feeTotals: CommonTypes.TaxAmount
				itemFees?: StoreOrderItemFee[]
				name?: string
		  }
		| {
				shouldOverridePrice: false
		  }
}
export type StoreOrderGiftCardRedemption = {
	uuid: string
	giftCardUuid: string
	name: string
	description: string
	amount: CommonTypes.Amount
}
export type StoreOrder = {
	uuid: string
	displayId?: number | null
	salesChannel: {
		uuid: string
		name: string
	}
	status: StoreOrderStatusType
	paymentStatus: CommonTypes.OrderPaymentStatusType
	currencyCode: string
	fulfillmentType: CommonTypes.FulfillmentTypeType
	fulfillmentStatus: CommonTypes.FulfillmentStatusType
	itemGroups: StoreOrderItemGroup[]
	totals: CommonTypes.TaxAmount
	totalAmountDue: CommonTypes.Amount
	giftCardRedemptions: StoreOrderGiftCardRedemption[]
}
export const SubmittedPaymentInfoType = {
	VerifoneCardData: 'VERIFONE_CARD_DATA',
	Verifone3dsDeviceId: 'VERIFONE_3DS_DEVICE_ID',
	Verifone3dsAuthenticationId: 'VERIFONE_3DS_AUTHENTICATION_ID',
	VerifoneWalletData: 'VERIFONE_WALLET_DATA'
} as const
export type SubmittedPaymentInfoTypeType = (typeof SubmittedPaymentInfoType)[keyof typeof SubmittedPaymentInfoType]
export type VerifoneEcomSubmittedPaymentInfo =
	| {
			type: 'VERIFONE_CARD_DATA'
			encryptedCardData?: string
			saveCard?: boolean
			errorCode?: string
			error?: string
	  }
	| {
			type: 'VERIFONE_3DS_DEVICE_ID'
			deviceId: string
	  }
	| {
			type: 'VERIFONE_3DS_AUTHENTICATION_ID'
			authenticationId: string
	  }
	| {
			type: 'VERIFONE_WALLET_DATA'
			walletType?: 'APPLE_PAY' | 'GOOGLE_PAY'
			walletPayload?: Record<never, never>
			errorCode?: string
			error?: string
	  }
export type StoreOrderInitiatedPaymentInfoBody = {
	clientReference: string
} & (
	| {
			provider: 'VIPPS_MOBILEPAY' | 'NETS_TERMINAL' | 'CASH' | 'CASH_ASYNC' | 'ADYEN_TERMINAL'
	  }
	| {
			provider: 'BLIKK_POS'
			qrCode: string
	  }
	| {
			provider: 'ADYEN_ECOM'
			returnUrl: string
			shopperReference?: string
	  }
	| {
			provider: 'VERIFONE_CHECKOUT'
			configurationType: 'CARD' | 'APPLE_PAY' | 'GOOGLE_PAY'
	  }
	| {
			provider: 'VERIFONE_ECOM'
			configurationType: 'CARD_CAPTURE' | 'CARD' | 'APPLE_PAY' | 'GOOGLE_PAY'
	  }
)
export const TransactionStatus = {
	PendingAuth: 'PENDING_AUTH',
	Authorized: 'AUTHORIZED',
	Completed: 'COMPLETED',
	Failed: 'FAILED',
	PendingCancel: 'PENDING_CANCEL',
	Canceled: 'CANCELED',
	Expired: 'EXPIRED'
} as const
export type TransactionStatusType = (typeof TransactionStatus)[keyof typeof TransactionStatus]
export type AdyenEcomData = {
	clientKey: string
	environment: 'TEST' | 'LIVE'
	sessionId: string
	sessionData: string
	countryCode: string
}
export type VerifoneCheckoutData = {
	checkoutId: string
	checkoutUrl?: string
}
export type VerifoneEcomData =
	| {
			configurationType: 'CARD_CAPTURE'
			checkoutId: string
			checkoutUrl?: string
	  }
	| {
			configurationType: 'CARD' | 'APPLE_PAY' | 'GOOGLE_PAY'
			cardCapturePublicKey: string
			amount: CommonTypes.Amount
			currencyCode: string
	  }
export type PaymentInfoTransaction = {
	uuid: string
	clientReference: string
	transactionStatus: TransactionStatusType
} & (
	| {
			provider:
				| 'ADYEN_TERMINAL'
				| 'BLIKK_ECOM'
				| 'BLIKK_POS'
				| 'CASH'
				| 'CASH_ASYNC'
				| 'VIPPS_MOBILEPAY'
				| 'NETS_TERMINAL'
				| 'STRAUMUR_ECOM'
	  }
	| {
			provider: 'ADYEN_ECOM'
			adyenData?: AdyenEcomData
	  }
	| {
			provider: 'VERIFONE_CHECKOUT'
			verifoneData?: VerifoneCheckoutData
	  }
	| {
			provider: 'VERIFONE_ECOM'
			verifoneData?: VerifoneEcomData
	  }
)
export type OrderPaymentInfoResponse = {
	status: CommonTypes.OrderPaymentStatusType
	transactions: PaymentInfoTransaction[]
}
export type StoreOrderListItem = {
	uuid: string
	displayId: number
	completedAt: number
	total: CommonTypes.TaxAmount
	currencyCode: string
	itemCount: number
	items: {
		imageUrl?: string
		title: string
	}[]
}

export const zPaymentProvider = z.enum([
	'ADYEN_TERMINAL',
	'ADYEN_ECOM',
	'BLIKK_ECOM',
	'BLIKK_POS',
	'CASH',
	'CASH_ASYNC',
	'VIPPS_MOBILEPAY',
	'NETS_TERMINAL',
	'VERIFONE_CHECKOUT',
	'VERIFONE_ECOM',
	'STRAUMUR_ECOM'
])
export const zStoreOrderStatus = z.enum(['DRAFT', 'COMPLETED', 'CANCELED'])
export const zQuantityInfo = z.intersection(
	z.object({
		quantity: z.number()
	}),
	z.union([
		z.object({
			pricingMethod: z.enum(['PER_UNIT'])
		}),
		z.object({
			pricingMethod: z.enum(['PRICE_EMBEDDED']),
			price: CommonTypes.zAmount
		}),
		z.object({
			pricingMethod: z.enum(['PER_WEIGHT', 'WEIGHT_EMBEDDED']),
			weight: z.number()
		})
	])
)
export const zStoreOrderItemFee = z.object({
	uuid: z.string(),
	feeUuid: z.string(),
	name: z.string(),
	totals: CommonTypes.zTaxAmount,
	quantity: z.number(),
	unitPrice: CommonTypes.zTaxAmount
})
export const zStoreOrderItemDiscount = z.object({
	uuid: z.string(),
	name: z.string(),
	totals: CommonTypes.zTaxAmount
})
export const zStoreOrderItem = z.object({
	uuid: z.string(),
	productTitle: z.string(),
	variantTitle: z.string(),
	variantImageUrl: z.string().optional(),
	sku: z.string().optional(),
	variantUuid: z.string(),
	scannedBarcode: z.string().optional(),
	totals: CommonTypes.zTaxAmount,
	unitPrice: CommonTypes.zTaxAmount.optional().nullable(),
	itemTotals: CommonTypes.zTaxAmount,
	feeTotals: CommonTypes.zTaxAmount,
	discountTotals: CommonTypes.zTaxAmount,
	quantityInfo: zQuantityInfo,
	itemFees: z.array(zStoreOrderItemFee),
	itemDiscounts: z.array(zStoreOrderItemDiscount)
})
export const zStoreOrderItemGroup = z.object({
	uuid: z.string(),
	items: z.array(zStoreOrderItem),
	priceInfo: z.union([
		z.object({
			shouldOverridePrice: z.literal(true),
			totals: CommonTypes.zTaxAmount,
			itemTotals: CommonTypes.zTaxAmount,
			discountTotals: CommonTypes.zTaxAmount,
			feeTotals: CommonTypes.zTaxAmount,
			itemFees: z.array(zStoreOrderItemFee).optional(),
			name: z.string().optional()
		}),
		z.object({
			shouldOverridePrice: z.literal(false)
		})
	])
})
export const zStoreOrderGiftCardRedemption = z.object({
	uuid: z.string(),
	giftCardUuid: z.string(),
	name: z.string(),
	description: z.string(),
	amount: CommonTypes.zAmount
})
export const zStoreOrder = z.object({
	uuid: z.string(),
	displayId: z.number().optional().nullable(),
	salesChannel: z.object({
		uuid: z.string(),
		name: z.string()
	}),
	status: zStoreOrderStatus,
	paymentStatus: CommonTypes.zOrderPaymentStatus,
	currencyCode: z.string(),
	fulfillmentType: CommonTypes.zFulfillmentType,
	fulfillmentStatus: CommonTypes.zFulfillmentStatus,
	itemGroups: z.array(zStoreOrderItemGroup),
	totals: CommonTypes.zTaxAmount,
	totalAmountDue: CommonTypes.zAmount,
	giftCardRedemptions: z.array(zStoreOrderGiftCardRedemption)
})
export const zSubmittedPaymentInfoType = z.enum([
	'VERIFONE_CARD_DATA',
	'VERIFONE_3DS_DEVICE_ID',
	'VERIFONE_3DS_AUTHENTICATION_ID',
	'VERIFONE_WALLET_DATA'
])
export const zVerifoneEcomSubmittedPaymentInfo = z.union([
	z.object({
		type: z.enum(['VERIFONE_CARD_DATA']),
		encryptedCardData: z.string().optional(),
		saveCard: z.boolean().optional(),
		errorCode: z.string().optional(),
		error: z.string().optional()
	}),
	z.object({
		type: z.enum(['VERIFONE_3DS_DEVICE_ID']),
		deviceId: z.string()
	}),
	z.object({
		type: z.enum(['VERIFONE_3DS_AUTHENTICATION_ID']),
		authenticationId: z.string()
	}),
	z.object({
		type: z.enum(['VERIFONE_WALLET_DATA']),
		walletType: z.enum(['APPLE_PAY', 'GOOGLE_PAY']).optional(),
		walletPayload: z.object({}).optional(),
		errorCode: z.string().optional(),
		error: z.string().optional()
	})
])
export const zStoreOrderInitiatedPaymentInfoBody = z.intersection(
	z.object({
		clientReference: z.string()
	}),
	z.union([
		z.object({
			provider: z.enum(['VIPPS_MOBILEPAY', 'NETS_TERMINAL', 'CASH', 'CASH_ASYNC', 'ADYEN_TERMINAL'])
		}),
		z.object({
			provider: z.enum(['BLIKK_POS']),
			qrCode: z.string()
		}),
		z.object({
			provider: z.enum(['ADYEN_ECOM']),
			returnUrl: z.string(),
			shopperReference: z.string().optional()
		}),
		z.object({
			provider: z.enum(['VERIFONE_CHECKOUT']),
			configurationType: z.enum(['CARD', 'APPLE_PAY', 'GOOGLE_PAY'])
		}),
		z.object({
			provider: z.enum(['VERIFONE_ECOM']),
			configurationType: z.enum(['CARD_CAPTURE', 'CARD', 'APPLE_PAY', 'GOOGLE_PAY'])
		})
	])
)
export const zTransactionStatus = z.enum([
	'PENDING_AUTH',
	'AUTHORIZED',
	'COMPLETED',
	'FAILED',
	'PENDING_CANCEL',
	'CANCELED',
	'EXPIRED'
])
export const zAdyenEcomData = z.object({
	clientKey: z.string(),
	environment: z.enum(['TEST', 'LIVE']),
	sessionId: z.string(),
	sessionData: z.string(),
	countryCode: z.string()
})
export const zVerifoneCheckoutData = z.object({
	checkoutId: z.string(),
	checkoutUrl: z.string().optional()
})
export const zVerifoneEcomData = z.union([
	z.object({
		configurationType: z.enum(['CARD_CAPTURE']),
		checkoutId: z.string(),
		checkoutUrl: z.string().optional()
	}),
	z.object({
		configurationType: z.enum(['CARD', 'APPLE_PAY', 'GOOGLE_PAY']),
		cardCapturePublicKey: z.string(),
		amount: CommonTypes.zAmount,
		currencyCode: z.string()
	})
])
export const zPaymentInfoTransaction = z.intersection(
	z.object({
		uuid: z.string(),
		clientReference: z.string(),
		transactionStatus: zTransactionStatus
	}),
	z.union([
		z.object({
			provider: z.enum([
				'ADYEN_TERMINAL',
				'BLIKK_ECOM',
				'BLIKK_POS',
				'CASH',
				'CASH_ASYNC',
				'VIPPS_MOBILEPAY',
				'NETS_TERMINAL',
				'STRAUMUR_ECOM'
			])
		}),
		z.object({
			provider: z.enum(['ADYEN_ECOM']),
			adyenData: zAdyenEcomData.optional().nullable()
		}),
		z.object({
			provider: z.enum(['VERIFONE_CHECKOUT']),
			verifoneData: zVerifoneCheckoutData.optional().nullable()
		}),
		z.object({
			provider: z.enum(['VERIFONE_ECOM']),
			verifoneData: zVerifoneEcomData.optional().nullable()
		})
	])
)
export const zOrderPaymentInfoResponse = z.object({
	status: CommonTypes.zOrderPaymentStatus,
	transactions: z.array(zPaymentInfoTransaction)
})
export const zStoreOrderListItem = z.object({
	uuid: z.string(),
	displayId: z.number(),
	completedAt: z.number(),
	total: CommonTypes.zTaxAmount,
	currencyCode: z.string(),
	itemCount: z.number(),
	items: z.array(
		z.object({
			imageUrl: z.string().optional(),
			title: z.string()
		})
	)
})
